// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3pIG3","logo":"Header_logo__3Xwkb","byMeBeer":"Header_byMeBeer__F6u4z","menuWrapper":"Header_menuWrapper__2efk1","menu":"Header_menu__2f3Gh"};